import { useCallback, useEffect, useRef, useState } from 'react';
import { API_URL, apiFetch, authHeaders } from '../../store';
import { LIVE_DEFAULTS } from '../data';

export default function useLiveBroadcast() {
  const [data, setData] = useState(null);
  const [online, setOnline] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const epoch = useRef(0), writing = useRef(false), etag = useRef('');
  useEffect(() => {
    let stopped = false, timer, controller;
    async function poll() {
      const started = epoch.current;
      controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        if (!writing.current) {
          const response = await fetch(`${API_URL}/live`, { signal: controller.signal, cache: 'no-cache', headers: etag.current ? { 'If-None-Match': etag.current } : {} });
          if (!response.ok && response.status !== 304) throw new Error('offline');
          const next = response.status === 304 ? null : await response.json();
          if (!stopped && started === epoch.current) {
            if (next) { setData(next); etag.current = response.headers.get('ETag') || ''; }
            setOnline(true);
          }
        }
      } catch { if (!stopped) setOnline(false); }
      finally { clearTimeout(timeout); if (!stopped) timer = setTimeout(poll, document.hidden ? 5000 : 1200); }
    }
    poll();
    return () => { stopped = true; clearTimeout(timer); controller?.abort(); };
  }, []);
  const save = useCallback(async (fields, revision) => {
    if (writing.current) return false;
    writing.current = true; epoch.current += 1; setBusy(true); setError('');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await apiFetch(`${API_URL}/live`, { method: 'PATCH', signal: controller.signal, headers: authHeaders(), body: JSON.stringify({ fields, revision }) });
      const next = await response.json();
      if (!response.ok) {
        if (next.state) setData(next.state);
        throw new Error(next.error || 'Не удалось подключить эфир');
      }
      setData(next); etag.current = ''; setOnline(true);
      return true;
    } catch (err) { setError(err.name === 'AbortError' ? 'Сервер не ответил. Проверьте соединение и повторите.' : err.message); return false; }
    finally { clearTimeout(timeout); writing.current = false; epoch.current += 1; setBusy(false); }
  }, []);
  return { data, live: { ...LIVE_DEFAULTS, ...data?.live }, online, busy, error, save };
}
